import React from 'react';
import { Route, HashRouter } from 'react-router-dom';
import { Switch } from 'react-router';
import Loadable from 'react-loadable';
import Spinner from 'react-spinkit';
import { history } from './history';
import * as routePaths from './LB/constants/routePaths';
import AuthRouter from './AuthRouter';
function logPageView() {
  window.scrollTo(0, 0);
}
const Loading = () => <Spinner name='double-bounce' />;
const Login = Loadable({
  loader: () => import('./LB/Containers/Login/index'),
  loading: Loading,
});
const SignUp = Loadable({
  loader: () => import('./LB/Containers/SignUp/index'),
  loading: Loading,
});
const HomeContent = Loadable({
  loader: () => import('./LB/Containers/MyHomePage/index'),
  loading: Loading,
});
const ReLocationContent = Loadable({
  loader: () => import('./LB/Containers/ReLocationContent/RelocationRoute/RelocationRoute'),
  loading: Loading,
});
const InventoryContent = Loadable({
  loader: () => import('./LB/Containers/InventoryContent/index'),
  loading: Loading,
});
const AddInventory = Loadable({
  loader: () => import('./LB/Containers/InventoryContent/AddInventory/index'),
  loading: Loading,
});
const EditInventory = Loadable({
  loader: () => import('./LB/Containers/InventoryContent/EditInventory/index'),
  loading: Loading,
});
const PintInventory = Loadable({
  loader: () => import('./LB/Containers/InventoryContent/PrintInventory/index'),
  loading: Loading,
});
const CreateCustomRoom = Loadable({
  loader: () => import('./LB/Containers/InventoryContent/CreateCustomRoom/index'),
  loading: Loading,
});
const ContactDetailsEdit = Loadable({
  loader: () => import('./LB/Containers/ContactDetails/ContactDetailsUpdate/index'),
  loading: Loading,
});
const ContactDetailsView = Loadable({
  loader: () => import('./LB/Containers/ContactDetails/ContactDetailsViews/index'),
  loading: Loading,
});
const CreateRelocation = Loadable({
  loader: () => import('./LB/Containers/CreateRelocation/index'),
  loading: Loading,
});
const Forms = Loadable({
  loader: () => import('./LB/Containers/Forms/index'),
  loading: Loading,
});
const CreateRelocation1 = Loadable({
  loader: () => import('./LB/Containers/CreateRelocation/index'),
  loading: Loading,
});
const Reimbursement = Loadable({
  loader: () => import('./LB/Containers/Reimbursement/index'),
  loading: Loading,
});
const MovePlanLetter = Loadable({
  loader: () => import('./LB/Containers/MovePlanLetter/index'),
  loading: Loading,
});
const SubmitNotice = Loadable({
  loader: () => import('./LB/Components/Notice/SubmitNotice'),
  loading: Loading,
});
const ErrorGoHome = Loadable({
  loader: () => import('./LB/Containers/Error/index'),
  loading: Loading,
});
const SubmitNoticeStep2 = Loadable({
  loader: () => import('./LB/Components/Notice/SubmitNoticeStep2'),
  loading: Loading,
});
const SubmitNoticeStep3 = Loadable({
  loader: () => import('./LB/Components/Notice/SubmitNoticeStep3'),
  loading: Loading,
});
const SubmitNoticeResult = Loadable({
  loader: () => import('./LB/Components/Notice/SubmitNoticeResult'),
  loading: Loading,
});
const Notice = Loadable({
  loader: () => import('./LB/Components/Notice/index'),
  loading: Loading,
});
const Captcha = Loadable({
  loader: () => import('./LB/Containers/Captcha/index'),
  loading: Loading,
});
export default () => {
  return (
    <HashRouter history={history} onUpdate={logPageView}>
      <Switch>
        <Route path={routePaths.INDEX} exact component={Login} />
        <Route path={routePaths.SIGNUP} component={SignUp} />
        <Route path ={routePaths.CAPTCHA}  component ={Captcha} />
        <AuthRouter path={routePaths.HOMEWILDCARD} component={HomeContent} />
        <AuthRouter path={routePaths.RELOCATIONREQUEST} component={ReLocationContent} />
        <AuthRouter path={routePaths.INVENTORYWITHKEY} component={InventoryContent} />
        <AuthRouter path={routePaths.INVENTORY} component={InventoryContent} />
        <AuthRouter path={routePaths.INVENTORYEDITWITHKEY} component={EditInventory} />
        <AuthRouter path={routePaths.PRINTINVENTORYWITHKEY} component={PintInventory} />
        <AuthRouter path={routePaths.CREATECUSTOMROOM} component={CreateCustomRoom} />
        <AuthRouter path={routePaths.CONTACTDETAILSVIEW} component={ContactDetailsView} />
        <AuthRouter path={routePaths.CONTACTDETAILSEDIT} component={ContactDetailsEdit} />
        <AuthRouter path={routePaths.CREATERELOCATION} component={CreateRelocation} />
        <AuthRouter path={routePaths.CREATERELOCATION1} component={CreateRelocation1} />
        <AuthRouter path={routePaths.ERRORGOHOME} component={ErrorGoHome} />
        <AuthRouter path={routePaths.REIMBURSEMENTWITHID} component={Reimbursement} />
        <AuthRouter path={routePaths.MOVEPLANLETTER} component={MovePlanLetter} />
        <AuthRouter path={routePaths.SUBMITNOTICEROOT} component={SubmitNotice} />
        <AuthRouter path={routePaths.SUBMITNOTICESTEP2} component={SubmitNoticeStep2} />
        <AuthRouter path={routePaths.SUBMITNOTICESTEP3} component={SubmitNoticeStep3} />
        <AuthRouter path={routePaths.SUBMITNOTICERESULT} component={SubmitNoticeResult} />
        <AuthRouter path={routePaths.NOTICEROOT} component={Notice} />
        <AuthRouter path={routePaths.FORMS} component={Forms} />
        <AuthRouter path={routePaths.ADDINVENTORY} component={AddInventory} />
      </Switch>
    </HashRouter>
  );
};
